import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./ThirdPartyFlow.scss";
import {
  CardContainer,
  LabelledInput,
  PrimaryButton,
  ScreenNavbar,
  TinyDescription,
} from "../../components";
import Loader from "../../components/Loader/Loader";
import { THIRD_PARTY_FLOW } from "../../constants/URLConstants";
import { WorkPlatformDetailsState } from "../../context/WorkPlatformDetailsContext";
import { ConfigState } from "../../context/ConfigContext";
import { trackEvent } from "../../analytics/sdkAnalytics";
import { LOGIN_BUTTON_CLICK } from "../../analytics/eventConstants";
import { useGetRedirectAuthFlow } from "../../utils/CustomHooks/useGetRedirectAuthFlow";
import { SDKParamsState } from "../../context/SdkParmasContext";
import LockedImageIcon from "../../assets/images/locked.svg";
import { LoaderWithStatusState } from "../../context/LoaderWithStatusContext";
import LoaderWithStatus from "../../components/LoaderWithStatus/LoaderWithStatus";
import { LoaderState } from "../../context/LoaderContext";
import { isEmpty } from "../../utils/sdk_utils";

function ThirdPartyFlow() {
  const params = useParams();
  const { workplatformDetails } = WorkPlatformDetailsState();
  const [platformDetail] = useState(
    workplatformDetails[params.workplatformid]
  );
  const [username, setUsername] = useState(null);
  const { sdkParams } = SDKParamsState();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState(null);
   const { loaderWithStatus } = LoaderWithStatusState();
    const isMounted = useRef();
    const { loader, dispatchLoaderContext } = LoaderState();
    const { isConnectLoader } = LoaderWithStatusState();
    const { configuration } = ConfigState();
    const [loaderMsgConfig, setLoaderMsgConfig] = useState(configuration.screens.short_loader_screen);

  const redirectAuthFlow = useGetRedirectAuthFlow(platformDetail.id, platformDetail.name || null, sdkParams, workplatformDetails);

   if (loader) {
        if (isConnectLoader && !isEmpty(loaderMsgConfig)) {
            return (
                <LoaderWithStatus
                    message={loaderMsgConfig.title.replace("{{PlatformName}}", platformDetail.name)}
                    platform={platformDetail.name}
                />
            );
        }
        return <Loader />;
    }


  return (
    <div className="page-background instagram-auth-container">
      <CardContainer>
        <ScreenNavbar
          backURL={-1}
          screenName={THIRD_PARTY_FLOW}
          workplatformDetails={{
            workplatformId: platformDetail?.id,
            workplatformName: platformDetail?.name,
          }}
        />
        <div className="platform-icon">
          <img src={platformDetail?.logo_url} alt="platform logo" />
        </div>
        <div className="platform-title">
          <p>Login to {platformDetail?.name} account</p>
        </div>
        <div className="platform-body">
          <LabelledInput
            name={platformDetail?.name ? `${platformDetail.name} username` : "username"}
            label={platformDetail?.name ? `${platformDetail.name} username` : "username"}
            value={username}
            onChange={(ev) => setUsername(ev.target.value)}
            style={errorMsg ? { borderColor: "red" } : {}}
          />
          {errorMsg && <p className="error-message">{errorMsg}</p>}
        </div>
        <div className="row mb-12  col-12 m-auto text-center retry-button-div">
          <TinyDescription>
            <div className="privacy-footer">
              <img
                src={LockedImageIcon}
                alt="privacy-icon"
                className="tiny-icon"
              />
              <span>Phyllo handles your account information securely.</span>
            </div>
          </TinyDescription>
          <PrimaryButton
          onClick={() => {
              redirectAuthFlow(username);
          }}
          style={username ? {} : { opacity: 0.5 }}
          disabled={!username}
          className="primary-btn"
          >
          Proceed
        </PrimaryButton>
        </div>
      </CardContainer>
    </div>
  );
}

export default ThirdPartyFlow; 